<template>
    <div class="order-detail">
        <van-nav-bar 
            title="订单详情" 
            left-arrow 
            @click-left="onClickLeft" 
            fixed 
            placeholder 
            style="z-index: 3;" 
        />
        
        <div class="detail-container" v-if="orderData.id">
            <!-- 订单状态卡片 -->
            <div class="status-card">
                <div class="status-info">
                    <div class="status-text" :class="'status-' + orderData.status">
                        {{ orderData.statusMsg }}
                    </div>
                    <div class="order-number">订单号：{{ orderData.ordersn }}</div>
                </div>
            </div>

            <!-- 用户信息 -->
            <div class="info-card">
                <div class="card-title">用户信息</div>
                <div class="order-user">
                    <img class="user-avatar" :src="orderData.user && orderData.user.avatar" alt="头像" />
                    <span class="user-nickname">{{ orderData.user && orderData.user.nickname }}</span>
                </div>
            </div>

            <!-- 商品信息 -->
            <div class="info-card">
                <div class="card-title">商品信息</div>
                <div class="order-content">
                    <div class="product-image">
                        <img :src="orderData.product && orderData.product.image" alt="">
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ orderData.product && orderData.product.name }}</div>
                        <div class="product-spec">规格：{{ orderData.product && orderData.product.spec }}</div>
                        <div class="product-price">¥{{ orderData.product && orderData.product.price }}</div>
                    </div>
                </div>
            </div>

            <!-- 订单信息 -->
            <div class="info-card">
                <div class="card-title">订单信息</div>
                <div class="order-info-list">
                    <div class="info-item">
                        <span class="label">购买数量：</span>
                        <span class="value">{{ orderData.purchase_number }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">支付金额：</span>
                        <span class="value price">¥{{ orderData.pay_price }}</span>
                    </div>
                </div>
            </div>

            <!-- 收货地址 -->
            <div class="info-card" v-if="orderAddress">
                <div class="card-title">收货地址</div>
                <div class="address-content">
                    <div class="address-item">
                        <van-icon name="location-o" class="address-icon" />
                        <div class="address-text">
                            <div class="address-name">
                                {{ orderAddress.name || '' }} {{ orderAddress.phone || '' }}
                            </div>
                            <div class="address-detail">
                                {{ formatAddress(orderAddress) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 审核按钮 -->
            <div class="action-bar" v-if="orderData.status == 0">
                <van-button 
                    type="primary" 
                    block 
                    @click="handleAudit"
                    class="audit-btn"
                >
                    审核订单
                </van-button>
            </div>
        </div>

        <van-empty v-else description="订单数据加载中..." />
    </div>
</template>

<script>
import { auditOrder } from '@/api/my'

export default {
    name: 'orderDetail',
    data() {
        return {
            orderData: {},
            orderAddress: null
        }
    },
    created() {
        this.initOrderData()
    },
    methods: {
        onClickLeft() {
            this.$router.back()
        },
        initOrderData() {
            // 从路由参数获取订单数据
            const orderData = this.$route.query.orderData
            
            if (orderData) {
                try {
                    // 如果是字符串，需要解析
                    this.orderData = typeof orderData === 'string' ? JSON.parse(orderData) : orderData
                    
                    // 解析地址信息
                    if (this.orderData.address) {
                        try {
                            this.orderAddress = typeof this.orderData.address === 'string' 
                                ? JSON.parse(this.orderData.address) 
                                : this.orderData.address
                        } catch (e) {
                            console.error('地址解析失败', e)
                            this.orderAddress = null
                        }
                    }
                } catch (e) {
                    console.error('订单数据解析失败', e)
                    this.$toast.fail('订单数据格式错误')
                }
            } else {
                this.$toast.fail('未获取到订单数据')
            }
        },
        formatAddress(address) {
            if (!address) return ''
            
            const parts = []
            if (address.province) parts.push(address.province)
            if (address.city) parts.push(address.city)
            if (address.district) parts.push(address.district)
            if (address.detail) parts.push(address.detail)
            
            return parts.join(' ')
        },
        handleAudit() {
            this.$dialog.confirm({
                closeOnClickOverlay: true,
                cancelButtonText: '拒绝',
                confirmButtonColor: '#1890ff',
                cancelButtonColor: '#ee0a24',
                message: `确认审核订单：${this.orderData.ordersn}？`,
            }).then(() => {
                // 确认审核通过
                this.submitAudit(this.orderData.ordersn, 1)
            }).catch(() => {
                // 拒绝审核
                this.submitAudit(this.orderData.ordersn, 4)
            })
        },
        submitAudit(ordersn, status) {
            auditOrder({
                ordersn: ordersn,
                status
            }).then(res => {
                if (res.code == 1) {
                    this.$toast.success('审核成功')
                    // 更新订单状态
                    this.orderData.status = status === 1 ? 1 : 4
                    this.orderData.statusMsg = status === 1 ? '待发货' : '已拒绝'
                    
                    // 延迟返回，让用户看到成功提示
                    setTimeout(() => {
                        this.$router.back()
                    }, 1500)
                } else {
                    this.$toast.fail(res.msg || '审核失败')
                }
            }).catch(err => {
                this.$toast.fail('审核请求失败，请重试')
            })
        }
    }
}
</script>

<style scoped lang="less">
.order-detail {
    min-height: 100vh;
    background: #f2f3f7;
    box-sizing: border-box;
    padding-bottom: var(--base-px-20);
}

.detail-container {
    padding: var(--base-px-12);
}

.status-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: var(--base-px-8);
    padding: var(--base-px-20);
    margin-bottom: var(--base-px-12);
    color: #fff;
}

.status-info {
    .status-text {
        font-size: var(--base-px-20);
        font-weight: 600;
        margin-bottom: var(--base-px-8);
        
        &.status-0 {
            color: #fff7e6;
        }
        
        &.status-1 {
            color: #e6f7ff;
        }
        
        &.status-2 {
            color: #f6ffed;
        }
        
        &.status-3 {
            color: #f6ffed;
        }
        
        &.status-4 {
            color: #fff1f0;
        }
    }
    
    .order-number {
        font-size: var(--base-px-14);
        opacity: 0.9;
    }
}

.info-card {
    background: #fff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-16);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.card-title {
    font-size: var(--base-px-16);
    font-weight: 600;
    color: #333;
    margin-bottom: var(--base-px-12);
    padding-bottom: var(--base-px-12);
    border-bottom: 1px solid #f0f0f0;
}

.order-user {
    display: flex;
    align-items: center;
    
    .user-avatar {
        width: var(--base-px-40);
        height: var(--base-px-40);
        border-radius: 50%;
        object-fit: cover;
        margin-right: var(--base-px-12);
        border: 1px solid #f0f0f0;
    }
    
    .user-nickname {
        font-size: var(--base-px-16);
        color: #333;
        font-weight: 500;
    }
}

.order-content {
    display: flex;
    align-items: center;
}

.product-image {
    width: var(--base-px-100);
    height: var(--base-px-100);
    border-radius: var(--base-px-8);
    overflow: hidden;
    flex-shrink: 0;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.product-info {
    flex: 1;
    margin-left: var(--base-px-12);
}

.product-name {
    font-size: var(--base-px-16);
    font-weight: 500;
    color: #333;
    margin-bottom: var(--base-px-8);
    line-height: 1.4;
}

.product-spec {
    font-size: var(--base-px-14);
    color: #999;
    margin-bottom: var(--base-px-8);
}

.product-price {
    font-size: var(--base-px-18);
    color: #ff4d4f;
    font-weight: 600;
}

.order-info-list {
    .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--base-px-8) 0;
        font-size: var(--base-px-14);
        
        .label {
            color: #999;
        }
        
        .value {
            color: #333;
            font-weight: 500;
            
            &.price {
                color: #ff4d4f;
                font-size: var(--base-px-16);
                font-weight: 600;
            }
        }
    }
}

.address-content {
    .address-item {
        display: flex;
        align-items: flex-start;
        padding: var(--base-px-8) 0;
    }
    
    .address-icon {
        font-size: var(--base-px-18);
        color: #1890ff;
        margin-right: var(--base-px-12);
        margin-top: var(--base-px-2);
        flex-shrink: 0;
    }
    
    .address-text {
        flex: 1;
    }
    
    .address-name {
        font-size: var(--base-px-15);
        font-weight: 500;
        color: #333;
        margin-bottom: var(--base-px-6);
    }
    
    .address-detail {
        font-size: var(--base-px-14);
        color: #666;
        line-height: 1.5;
    }
}

.action-bar {
    padding: var(--base-px-16) 0;
}

.audit-btn {
    height: var(--base-px-44);
    border-radius: var(--base-px-8);
    font-size: var(--base-px-16);
    font-weight: 500;
    background: #245DC4;
    border: none;
}
</style>

